export default () => ({
  marginTopNegative:{
    marginTop: '0',
    paddingTop: '51px',
  },
  myFilesWrapper: {
    border: '#dc762f 3px solid',
    borderRadius: '35px',
    marginBottom: '80px',
    marginLeft: '3%',
    marginRight: '3%',
    paddingBottom: '20px',
    background: 'white',
    paddingRight: '3%',
    paddingLeft: '3%',
  },
  customTooltip: {
    border: '#dc762f 1px solid',
  },
});
